// extracted by mini-css-extract-plugin
export default {"main":"app_main__T8LM7","centered":"app_centered__luf6u"};